/* ==========================================
   HEADER SECTION JAVASCRIPT
   Fixed header, mobile menu, search, dropdowns
   ========================================== */

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  // --- Compute header height for body padding ---
  const headerGroup = document.getElementById('site-header');
  if (headerGroup) {
    const updateHeaderHeight = () => {
      const height = headerGroup.offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
  }

  // --- Mobile Menu ---
  const menuToggle = header.querySelector('[data-menu-toggle]');
  const mobileMenu = header.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', !isOpen);

      if (isOpen) {
        mobileMenu.classList.remove('is-open');
        setTimeout(() => { mobileMenu.hidden = true; }, 250);
        document.body.style.overflow = '';
      } else {
        mobileMenu.hidden = false;
        requestAnimationFrame(() => {
          mobileMenu.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
      }
    });

    // Fermer en cliquant sur le fond assombri (hors du panneau coulissant)
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('is-open');
        setTimeout(() => { mobileMenu.hidden = true; }, 250);
        document.body.style.overflow = '';
      }
    });

    // Mobile dropdown toggles
    const mobileDropdownToggles = mobileMenu.querySelectorAll('[data-mobile-dropdown-toggle]');
    mobileDropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const dropdown = toggle.nextElementSibling;

        toggle.setAttribute('aria-expanded', !isExpanded);
        dropdown.hidden = isExpanded;
      });
    });
  }

  // --- Mega Dropdown (Catégories) ---
  const megaTriggers = header.querySelectorAll('[data-mega-trigger]');
  megaTriggers.forEach(trigger => {
    const type = trigger.getAttribute('data-mega-trigger');
    const dropdown = header.querySelector(`[data-mega-dropdown="${type}"]`);
    if (!dropdown) return;

    const navItem = trigger.closest('.header__nav-item');
    const arrow = dropdown.querySelector('.header__mega-dropdown-arrow');
    let hideTimeout;

    const positionArrow = () => {
      if (!arrow) return;
      const triggerRect = trigger.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();
      const triggerCenter = triggerRect.left + triggerRect.width / 2;
      const arrowLeft = triggerCenter - dropdownRect.left;
      arrow.style.left = arrowLeft + 'px';
    };

    const show = () => {
      clearTimeout(hideTimeout);
      dropdown.classList.add('is-visible');
      dropdown.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      positionArrow();
    };

    const hide = () => {
      hideTimeout = setTimeout(() => {
        dropdown.classList.remove('is-visible');
        dropdown.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      }, 150);
    };

    navItem.addEventListener('mouseenter', show);
    navItem.addEventListener('mouseleave', hide);
    dropdown.addEventListener('mouseenter', show);
    dropdown.addEventListener('mouseleave', hide);

    // Keyboard: Escape to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdown.classList.contains('is-visible')) {
        dropdown.classList.remove('is-visible');
        dropdown.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  // --- Simple Dropdowns (Catégories, Marques) ---
  const dropdownToggles = header.querySelectorAll('[data-dropdown-toggle]');
  dropdownToggles.forEach(toggle => {
    const navItem = toggle.closest('.header__nav-item');
    const dropdown = navItem.querySelector('[data-dropdown]');
    if (!dropdown || !navItem) return;

    let hideTimeout;
    const show = () => {
      clearTimeout(hideTimeout);
      dropdown.classList.add('is-visible');
      toggle.setAttribute('aria-expanded', 'true');
    };
    const hide = () => {
      hideTimeout = setTimeout(() => {
        dropdown.classList.remove('is-visible');
        toggle.setAttribute('aria-expanded', 'false');
      }, 150);
    };

    navItem.addEventListener('mouseenter', show);
    navItem.addEventListener('mouseleave', hide);
  });

  // --- Predictive Search ---
  const searchInputs = header.querySelectorAll('[data-search-input]');
  searchInputs.forEach(searchInput => {
    let debounceTimer;
    let controller = null;
    const searchBar = searchInput.closest('.header__search-bar');
    const predictiveSearch = searchBar ? searchBar.querySelector('#predictive-search') : null;

    const cancelPending = () => {
      clearTimeout(debounceTimer);
      if (controller) {
        controller.abort();
        controller = null;
      }
    };

    searchInput.addEventListener('input', () => {
      cancelPending();
      const query = searchInput.value.trim();

      if (query.length < 2) {
        if (predictiveSearch) predictiveSearch.hidden = true;
        return;
      }

      debounceTimer = setTimeout(() => {
        controller = new AbortController();
        fetchPredictiveSearch(query, predictiveSearch, controller.signal, searchInput);
      }, 300);
    });

    if (predictiveSearch) {
      // Échap : ferme le panneau et annule la requête en cours
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          cancelPending();
          predictiveSearch.hidden = true;
        }
      });

      // Retour dans le champ : rouvre le panneau s'il contient déjà des résultats
      searchInput.addEventListener('focus', () => {
        if (searchInput.value.trim().length < 2) return;
        const group = predictiveSearch.querySelector('[data-search-group="products"]');
        const noResults = predictiveSearch.querySelector('.predictive-search__no-results');
        if ((group && !group.hidden) || (noResults && !noResults.hidden)) {
          predictiveSearch.hidden = false;
        }
      });

      // Clic en dehors de la barre de recherche : ferme le panneau
      document.addEventListener('click', (event) => {
        if (!predictiveSearch.hidden && searchBar && !searchBar.contains(event.target)) {
          predictiveSearch.hidden = true;
        }
      });
    }
  });
});

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

async function fetchPredictiveSearch(query, container, signal, searchInput) {
  if (!container) return;

  const loading = container.querySelector('.predictive-search__loading');
  const noResults = container.querySelector('.predictive-search__no-results');

  container.hidden = false;
  if (noResults) noResults.hidden = true;
  if (loading) loading.hidden = true;

  try {
    /* Use /search with predictive view — searches ALL indexed fields including metafields (reference) */
    const response = await fetch(
      `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(query)}&type=product&view=predictive`,
      { signal }
    );
    const text = await response.text();
    // Réponse tardive : la saisie a changé entre-temps, on ignore
    if (signal && signal.aborted) return;
    if (searchInput && searchInput.value.trim() !== query) return;
    const items = JSON.parse(text.trim());

    let hasResults = false;
    const group = container.querySelector('[data-search-group="products"]');
    const list = container.querySelector('[data-search-results="products"]');

    if (group && list) {
      if (items.length > 0) {
        hasResults = true;
        group.hidden = false;
        list.innerHTML = items.map(function(item) {
          var image = item.image ? '<img src="' + item.image + '" alt="" class="predictive-search__product-image">' : '';
          var price = item.price || '';
          var comparePrice = item.compare_at_price || '';
          var ref = item.reference ? '<span class="predictive-search__product-ref">Réf. ' + escapeHtml(item.reference) + '</span>' : '';
          return '<li class="predictive-search__product-item">' +
            '<a href="' + item.url + '" class="predictive-search__product-link">' +
              image +
              '<div class="predictive-search__product-info">' +
                '<span class="predictive-search__product-title">' + escapeHtml(item.title) + '</span>' +
                ref +
                '<div class="predictive-search__product-pricing">' +
                  (comparePrice ? '<span class="predictive-search__product-compare">' + comparePrice + '</span>' : '') +
                  (price ? '<span class="predictive-search__product-price' + (comparePrice ? ' predictive-search__product-price--on-sale' : '') + '">' + price + '</span>' : '') +
                '</div>' +
              '</div>' +
            '</a>' +
          '</li>';
        }).join('');
      } else {
        group.hidden = true;
        list.innerHTML = '';
      }
    }

    if (!hasResults && noResults) {
      noResults.hidden = false;
    }
  } catch (error) {
    if (error && error.name === 'AbortError') return;
    console.error('Predictive search error:', error);
  } finally {
    if (loading) loading.hidden = true;
  }
}
